<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div v-if="!isLoaded" class="card">
                    <div class="p-3 pb-0 card-header">
                    </div>
                    <div class="card-body">
                        <div class="d-flex justify-content-center align-items-center" style="height: 50vh;">
                            <div class="text-center">
                                <img src="@/assets/img/allo-icon.svg" alt="icon" height="50" width="50">
                                <h4 class="fw-bold mt-3">Cargando Información del Usuario...</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isLoaded" class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección de Título -->
                            <div class="d-flex align-items-center">
                                <h6 class="mb-2 ms-2">Registros de Tiempo de {{ userName }}</h6>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="me-2">De:</span> <input type="date" class="form-control"
                                    v-model="startDate">
                                <span class="ms-2 me-2">A:</span><input type="date" class="form-control"
                                    v-model="endDate">
                            </div>
                            <div class="d-flex align-items-center">
                                <button class="btn btn-secondary mb-0" @click="getTimeRecords">Cargar Datos</button>
                            </div>
                            <div>
                                <button class="btn btn-warning mb-0"
                                    @click="openModal({ user_id: userId }, 'CreateCompleteTimeRecord')">+ Agregar
                                    Registro</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <th>Id</th>
                                    <th>Registrado</th>
                                    <th>Hrs</th>
                                    <th>Evento</th>
                                    <th>Fecha</th>
                                    <th>H.I.</th>
                                    <th>H.F.</th>
                                    <th>Acciones</th>
                                    <th>Cliente</th>
                                    <th>Proyecto</th>
                                    <th>Actividad</th>
                                    <th>Notas</th>
                                    <th>Extra</th>
                                    <th>Facturable</th>
                                    <th>En Sitio</th>
                                    <th>Aut. PM</th>
                                    <th>P.M.</th>
                                    <th>Autorizado</th>
                                    <th>Autorizador</th>
                                    <th>Enviado</th>
                                    <th>Activo</th>

                                </thead>
                                <tbody>
                                    <tr v-for="(tr, idx) in records" :key="idx">
                                        <td>{{ tr.time_record_id }}</td>
                                        <td>{{ formatDateTime(tr.recorded_on) }}</td>
                                        <td>{{ tr.total_hours }}</td>
                                        <td>{{ tr.is_event ? 'SI' : 'NO' }}</td>
                                        <td>{{ formatDate(tr.date) }}</td>
                                        <td>{{ formatTime(tr.start_time) }}</td>
                                        <td>{{ formatTime(tr.end_time) }}</td>
                                        <td>
                                            <button class="btn btn-danger mb-0" @click="deleteRecord(tr.time_record_id)">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                            <button class="btn btn-secondary mb-0 ms-2"
                                                @click="openModal({ time_record_id: tr.time_record_id }, 'FreeEditTimeRecord')">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                        </td>
                                        <td>{{ tr.client }}</td>
                                        <td>{{ tr.identifier }} - {{ tr.project }}</td>
                                        <td>{{ tr.activity }} - {{ tr.description }}</td>
                                        <td>{{ tr.notes }}</td>
                                        <td>{{ tr.is_extra_time ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.is_billable ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.on_site ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.auth_by_pm ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.project_manager }}</td>
                                        <td>{{ tr.is_auth ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.authorizer }}</td>
                                        <td>{{ tr.sent ? 'SI' : 'NO' }}</td>
                                        <td>{{ tr.active ? 'SI' : 'NO' }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal">
    </Modal>
</template>
<script setup>

import { ref, onMounted, shallowRef } from 'vue'

const props = defineProps({
    id: {
        type: String,
        required: true
    }
})

import Modal from './components/Modal.vue';
import FreeEditTimeRecord from './components/forms/FreeEditTimeRecord.vue';
import CreateCompleteTimeRecord from './components/forms/CreateCompleteTimeRecord.vue';

const formComponents = {
    FreeEditTimeRecord: FreeEditTimeRecord,
    CreateCompleteTimeRecord: CreateCompleteTimeRecord
}

const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData = ref(null)

// Función para abrir el modal con un formulario y datos específicos
const openModal = (data, formType) => {
    selectedData.value = data || {}; // Si no se pasa nada, se inicializa como objeto vacío
    selectedFormComponent.value = formComponents[formType] || null;

    // Asignar título dinámico
    const titles = {
        CreateEvent: "Registrar Evento",
        EditEvent: "Editar Evento",
    };
    modalTitle.value = titles[formType] || "Editar Información";
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const formatDate = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
}

const formatTime = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}

const formatDateTime = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}


import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const isLoaded = ref(true)
const userId = ref(props.id)
const records = ref([])
const userName = ref('')

const endDate = ref(new Date().toISOString().split('T')[0]);

const start = new Date();
start.setMonth(start.getMonth() - 1);
const startDate = ref(start.toISOString().split('T')[0]);

const getTimeRecords = async () => {

    const body = { start: startDate.value, end: endDate.value, user_id: userId.value }

    try {
        const response = await axios.post(`${API_BASE_URL}/all-time-records-by-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        records.value = response.data.data;
        userName.value = response.data.name;

    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const deleteRecord = async (id) => {

    const body = { time_record_id: id }

    if(!confirm(`¿Deseas eliminar PERMANENTEMENTE este registro id: ${id}?`)){ return; }

    try {
        const response = await axios.post(`${API_BASE_URL}/delete-record`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if(response && response.status === 200 && response.data.msg){
            alert(response.data.msg)
            getTimeRecords()
        }

    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }

}

onMounted(
    async () => {
        await getTimeRecords()
    }
)


</script>